module.exports = __webpack_public_path__ + "img/logo-zamzam.61adbb96.png";